import { privateAxios } from "../axiosInstances";

export const getOrganiserExhibitorsAsCsv = async () => {
  const { data } = await privateAxios.get<string>(
    "/organiser/exhibitors/export"
  );
  return data;
};
